module.exports = __webpack_public_path__ + "img/SA_SAFe5.e8076ee5.png";